// Curated list of common disposable/temporary email providers, used to block
// signup with throwaway addresses. Not exhaustive — extend as new ones show up.
export const DISPOSABLE_EMAIL_DOMAINS = new Set([
  '10minutemail.com',
  '10minutemail.net',
  'guerrillamail.com',
  'guerrillamail.net',
  'guerrillamail.org',
  'guerrillamail.biz',
  'sharklasers.com',
  'mailinator.com',
  'mailinator.net',
  'mailinator.org',
  'temp-mail.org',
  'tempmail.com',
  'tempmail.net',
  'tempmailo.com',
  'throwawaymail.com',
  'yopmail.com',
  'yopmail.net',
  'yopmail.fr',
  'trashmail.com',
  'trashmail.net',
  'getnada.com',
  'dispostable.com',
  'fakeinbox.com',
  'mintemail.com',
  'moakt.com',
  'mohmal.com',
  'emailondeck.com',
  'maildrop.cc',
  'mailnesia.com',
  '33mail.com',
  'spamgourmet.com',
  'discard.email',
  'discardmail.com',
  'tempinbox.com',
  'mail-temp.com',
  'temp-mail.io',
  'inboxbear.com',
  'burnermail.io',
  'anonaddy.com',
]);

export const isDisposableEmail = (email: string) => {
  const domain = email.trim().toLowerCase().split('@')[1];
  if (!domain) return false;

  return DISPOSABLE_EMAIL_DOMAINS.has(domain);
};
